export default {
  UNPUBLISH_CONFIRM_PHRASE: 'UNPUBLISH',
  RESET_CONFIRM_PHRASE: 'RESET',
};
